import { SEO } from "../components/SEO";
import { Marquee } from "../components/Marquee";
import { ServiceFinder } from "../components/ServiceFinder";
import { HeroScene } from "../scenes/HeroScene";
import { CredibilityBar } from "../scenes/CredibilityBar";
import { ServiceExplorer } from "../scenes/ServiceExplorer";
import { WhyDcc } from "../scenes/WhyDcc";
import { EvidenceScene } from "../scenes/EvidenceScene";
import { EvidenceExample } from "../scenes/EvidenceExample";
import { ClientProof } from "../scenes/ClientProof";
import { Testimonials } from "../scenes/Testimonials";
import { WorkScene } from "../scenes/WorkScene";
import { LocationsCompact } from "../scenes/LocationsCompact";
import { ConvertScene } from "../scenes/ConvertScene";
import { SITE } from "../data/site";

// Homepage — production order (2026-08-29 brief):
// 01 Hero · 02 Verified track record · 03 Find the right service ·
// 04 Five specialist services · 05 Why DCC + process + evidence standard ·
// 06 Featured clients + testimonials · 07 Industries · 08 Project stories ·
// 09 Priority locations · 10 Final survey CTA.
export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE.name,
    url: SITE.url,
  };
  return (
    <>
      <SEO title="Duct Clean Co. — Specialist Commercial Duct Cleaning, India" description={SITE.description} path="/" jsonLd={jsonLd} image="/assets/dcc/hero-main.webp" />

      {/* 01 — Hero */}
      <HeroScene />

      {/* 02 — Verified track record (all figures from central FACTS) */}
      <CredibilityBar />

      <Marquee items={["FASTER", "SAFER", "CLEANER"]} />

      {/* 03 — Find the right service (problem-led) */}
      <ServiceFinder />

      {/* 04 — Five specialist services (scroll-led, with direct-select tabs) */}
      <ServiceExplorer />

      {/* 05 — Why DCC + accountable process + evidence standard (merged) */}
      <WhyDcc />
      <EvidenceScene />
      <EvidenceExample />

      {/* 06 — Featured clients, standards and selected testimonials */}
      <ClientProof />
      <Testimonials />

      {/* 07 — Selected project stories (industry + location signals preserved here and in Locations) */}
      <WorkScene />

      {/* 09 — Priority locations */}
      <LocationsCompact />

      {/* 10 — Final free site survey CTA */}
      <ConvertScene />
    </>
  );
}
